var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9705 13.9705 18 9 18C4.02943 18 0 13.9705 0 9C0 4.02943 4.02943 0 9 0C13.9705 0 18 4.02943 18 9ZM6.27267 6.27269C6.53627 6.00908 6.96365 6.00908 7.22727 6.27269L9 8.04537L10.7726 6.2727C11.0362 6.0091 11.4637 6.0091 11.7273 6.2727C11.9909 6.5363 11.9909 6.9637 11.7273 7.22727L9.95454 9L11.7273 10.7726C11.9909 11.0362 11.9909 11.4637 11.7273 11.7273C11.4637 11.9909 11.0362 11.9909 10.7726 11.7273L9 9.95463L7.22727 11.7273C6.96368 11.9909 6.53629 11.9909 6.27269 11.7273C6.00908 11.4637 6.00908 11.0362 6.27269 10.7727L8.04537 9L6.27267 7.22727C6.00906 6.96368 6.00906 6.53629 6.27267 6.27269Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon2);
export default __webpack_public_path__ + "static/media/CloseIcon_2.eacbad35ab29dc3bdc1b09dd4af9fbea.svg";
export { ForwardRef as ReactComponent };